import { nullCheck } from "../utils/dataHelpers";

export default class CarrierEquipmentSerializer {
  static serialize(data) {
    const payload = {
      __type: "drs_payee_equip",
      company_id: "TMS",
      ...data,
      equipment_count: data.equipmentCount,
      equipment_type_id: data.equipmentTypeId,
      payee_id: data.payeeId
    };

    const customProperties = [
      "equipmentCount",
      "equipmentTypeId",
      "equipmentTypeName",
      "payeeId"
    ];

    customProperties.forEach(prop => delete payload[prop]);
    return payload;
  }

  static deSerialize(data) {
    return {
      equipmentCount: data.equipment_count,
      equipmentTypeId: data.equipment_type_id,
      payeeId: data.payee_id,
      equipmentTypeName: nullCheck(data, null, "equipment_type_id_row", "descr"),
      ...data
    };
  }
}